import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { ChatContextProvider } from '@src/components/sco/Chat/ChatContext';
import { useMatchingContext } from '@src/components/sco/Matching/Layout/MatchingContext';
import { UserMatchChatList } from '@src/components/sco/Matching/UserMatchChatList';
import { UserMatchChatThread } from '@src/components/sco/Matching/UserMatchChatThread';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { useEffect } from 'react';
export const MatchingAside = () => {
  const $ = _c(11);
  const layout = useParentAppLayout();
  const matchingContext = useMatchingContext();
  let t0;
  if ($[0] !== layout || $[1] !== matchingContext.chatThreadId) {
    t0 = () => {
      if (matchingContext.chatThreadId && layout.isPanelClosed("matching-aside")) {
        layout.openPanel("matching-aside");
      }
    };
    $[0] = layout;
    $[1] = matchingContext.chatThreadId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== matchingContext.chatThreadId) {
    t1 = [matchingContext.chatThreadId];
    $[3] = matchingContext.chatThreadId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      bgColor: "transparent"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== matchingContext.chatThreadId) {
    t3 = matchingContext.chatThreadId ? <UserMatchChatThread threadId={matchingContext.chatThreadId} /> : <UserMatchChatList />;
    $[6] = matchingContext.chatThreadId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== matchingContext.chatThreadId || $[9] !== t3) {
    t4 = <VStack align="stretch" bgColor="colorPalette.container" gap={0} height="full" justify="stretch" width="full"><PaywalledAction contentPermission="canAccessMemberMatching" title="Upgrade to access messaging." upgradeBoxProps={t2} variant="boxed"><ChatContextProvider activeThreadId={matchingContext.chatThreadId}>{t3}</ChatContextProvider></PaywalledAction></VStack>;
    $[8] = matchingContext.chatThreadId;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};